import moment from 'moment'
import i18n from '@/i18n'

export const formatDate = (date: string) => {
  moment.locale('en')
  return moment(date).format('DD MMM YYYY - HH[h]mm')
}

export const formatDateOnly = (date: Date) => {
  const formatOptions: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }

  return new Date(date).toLocaleDateString(i18n.locale, formatOptions)
}
